import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 0c-2.256 0-4.442.3-6.522.861L16.304 25l2.174 24.139c2.08.56 4.265.861 6.522.861 13.807 0 25-11.193 25-25S38.807 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "m16.304 25 2.174 24.139c2.08.56 4.265.861 6.522.861 13.807 0 25-11.193 25-25H16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25c0 9.476 5.272 17.72 13.043 21.96V3.04C5.274 7.28 0 15.524 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25c0 11.551 7.834 21.27 18.478 24.14V.861C7.834 3.73 0 13.45 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "m9.447 18.479 1.618 4.982h5.24l-4.239 3.08 1.619 4.981-4.238-3.079-4.239 3.08 1.62-4.983-4.239-3.08h5.239l1.619-4.981Z"
}));
FlagGW.displayName = 'FlagGW';
export default withFlagWrapper(FlagGW);
//# sourceMappingURL=index.js.map